import type { PortableTextBlock, PortableTextTextBlock } from '@sanity/types';
import { type Component } from 'vue';
import type { ZodSchema, ZodType, ZodTypeDef } from 'zod';

export interface FieldSchema {
  component: Component;
  label?: string | null;
  type?: string | null;
  placeholder?: string | null;
  description?: string | null;
  defaultValue?: any;
  required?: boolean;
  options?: Array<{ title: string; value: string; }>;
  validation?: ZodType<any, ZodTypeDef, any>;
  noteText?: null | Array<PortableTextTextBlock>;
}

export interface FormSchema {
  [key: string]: FieldSchema;
}

export interface UseDynamicForm {
  formSchema: FormSchema;
  validationSchema?: ZodSchema;
}

export enum TurnstileStatusValue {
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
  VERIFIED = 'verified',
}
export interface TurnstileStatus {
  status: TurnstileStatusValue;
  error?: string | null;
}